import { columnForField, defaultColumnWidth } from "../../../Grid/columnForField";
import { kendoDateCell } from "../../../Layout/Grid/Cell/DateCell";
import { bidPackObjectName } from "../BidPack";
import { BidPackOverviewItem } from "../BidPackOverviewItem";

import {
  bidPackRateAgreementStateColumnMenu,
  bidPackRateAgreementStateEnumCell,
  bidPackTransportTypeColumnMenu,
  bidPackTransportTypeEnumCell,
} from "./BidPackGridColumnMenu";

export const BidPackGridColumns = () => {
  return [
    columnForField<BidPackOverviewItem>("TransportType", {
      title: "Transport Type",
      filter: "numeric",
      hideFilterCell: true,
      columnMenu: bidPackTransportTypeColumnMenu,
      cell: bidPackTransportTypeEnumCell,
      width: defaultColumnWidth,
    }),
    columnForField<BidPackOverviewItem>("Name", {
      title: bidPackObjectName,
      width: "200px",
    }),
    columnForField<BidPackOverviewItem>("DestinationName", {
      title: "Destination Name",
      width: defaultColumnWidth,
    }),
    columnForField<BidPackOverviewItem>("StartDate", {
      title: "Start Date",
      filter: "date",
      width: "220px",
      cell: kendoDateCell(),
    }),
    columnForField<BidPackOverviewItem>("EndDate", {
      title: "End Date",
      filter: "date",
      cell: kendoDateCell(),
      width: "220px",
    }),
    columnForField<BidPackOverviewItem>("AssignedCarrierName", {
      title: "Assigned Carrier",
      width: "300px",
    }),
    columnForField<BidPackOverviewItem>("AssignedRateAgreement", {
      title: "Assigned Rate Agreement",
      width: "220px",
    }),
    columnForField<BidPackOverviewItem>("TT", {
      width: defaultColumnWidth,
    }),
    columnForField<BidPackOverviewItem>("CB", {
      width: defaultColumnWidth,
    }),
    columnForField<BidPackOverviewItem>("RateAgreementStatus", {
      title: "Status",
      hideFilterCell: true,
      columnMenu: bidPackRateAgreementStateColumnMenu,
      cell: bidPackRateAgreementStateEnumCell,
      width: defaultColumnWidth,
    }),
  ];
};
